<template>
    <v-dialog v-model="shows" max-width="720" persistent>
        <template v-slot:activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-card v-bind="{ loading }">
            <v-card-title>
                <template v-if="isCreate">설비 생성</template>
                <template v-else>설비 상세</template>
                <v-spacer />
                <v-btn absolute right text icon @click="shows = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-divider />
            <v-card-text class="pa-0" style="max-height: calc(90vh - 16px - 32px - 10px - 1px - 1px - 60px); overflow-y: auto">
                <v-row no-gutters>
                    <v-col cols="12" sm="4">
                        <v-card-subtitle class="grey lighten-5">이미지</v-card-subtitle>
                        <v-divider />
                        <v-card-text> <v-preview-input v-model="inputs.thumb" :aspect-ratio="1 / 1" /> </v-card-text>
                        <v-divider />
                        <v-card-text> <images-input v-model="inputs.photos" cols="3" /> </v-card-text>
                    </v-col>
                    <v-col cols="12" sm="auto"> <v-divider class="d-none d-sm-block" vertical /> <v-divider class="d-block d-sm-none" /> </v-col>
                    <v-col>
                        <v-card-subtitle class="grey lighten-5">기본 정보</v-card-subtitle>
                        <v-divider />
                        <v-card-text>
                            <v-row no-gutters class="ma-n2">
                                <v-col class="pa-2" cols="3"> <v-select label="설비유형" v-model="inputs.type" :items="subjectTypes" v-bind="attrs_input" :disabled="!!inputs._id" /> </v-col>
                                <v-col class="pa-2" cols="9"> <v-text-field label="설비명" v-model="inputs.name" v-bind="attrs_input" /> </v-col>
                                <v-col class="pa-2" cols="6"> <v-select label="비용유형" v-model="inputs.isFree" :items="isFreeItems" v-bind="attrs_input" /> </v-col>
                                <v-col class="pa-2" cols="6">
                                    <v-fade-transition> <v-text-field label="비용표기" v-model="inputs.charge" v-show="!inputs.isFree" v-bind="attrs_input" /> </v-fade-transition>
                                </v-col>
                                <v-col class="pa-2" cols="6"> <v-text-field label="용도" v-model="inputs.usage" v-bind="attrs_input" /> </v-col>
                                <v-col class="pa-2" cols="6"> <v-text-field label="장소" v-model="inputs.location" v-bind="attrs_input" /> </v-col>
                                <v-col class="pa-2" cols="6"> <v-text-field label="담당자" v-model="inputs.worker" v-bind="attrs_input" /> </v-col>
                                <v-col class="pa-2" cols="6"> <v-text-field label="연락처" v-model="inputs.contact" v-bind="attrs_input" /> </v-col>
                                <template v-if="isEquipment">
                                    <v-col class="pa-2" cols="6"> <v-text-field label="구축일자" v-model="inputs.dateOfConstruction" v-bind="attrs_input" /> </v-col>
                                    <v-col class="pa-2" cols="6"> <v-text-field label="표준분류" v-model="inputs.classificationName" v-bind="attrs_input" /> </v-col>
                                    <v-col class="pa-2" cols="6"> <v-text-field label="설치장소" v-model="inputs.placeOfInstallment" v-bind="attrs_input" /> </v-col>
                                    <v-col class="pa-2" cols="6"> <v-text-field label="활용범위" v-model="inputs.rangeOfApplication" v-bind="attrs_input" /> </v-col>
                                </template>
                                <v-col class="pa-2" cols="12"> <v-textarea label="상세" v-model="inputs.detail" rows="2" v-bind="attrs_input" /> </v-col>
                            </v-row>
                        </v-card-text>
                    </v-col>
                    <v-col cols="12"> <v-divider /> </v-col>
                    <v-col cols="12">
                        <form-table-row label="사용가능요일" cols="3" md="2">
                            <v-row no-gutters justify="start" align="stretch">
                                <v-col cols="3" sm="" v-for="{ label, value } in businessDays" :key="value">
                                    <v-checkbox v-model="inputs.businessDays" v-bind="{ label, value }" dense hide-details multiple class="mt-0" />
                                </v-col>
                            </v-row>
                        </form-table-row>
                        <form-table-row label="사용유형" cols="3" md="2">
                            <v-select v-model="inputs.isWholeDayRent" :items="isWholeDayRentItems" v-bind="attrs_input" :outlined="false" />
                        </form-table-row>
                        <v-expand-transition>
                            <form-table-row v-show="!inputs.isWholeDayRent" label="사용가능시간" cols="3" md="2">
                                <v-row no-gutters justify="start" align="stretch">
                                    <v-col cols="4" sm="3" md="2" v-for="{ label, value } in businessHours" :key="value">
                                        <v-checkbox v-model="inputs.businessHours" v-bind="{ label, value }" dense hide-details multiple class="mt-0" />
                                    </v-col>
                                </v-row>
                            </form-table-row>
                        </v-expand-transition>
                        <form-table-row label="사용불가일자" cols="3" md="2">
                            <v-chip-group v-model="inputs.holidays" column>
                                <v-chip v-for="holiday in inputs.holidays" :key="holiday" close @click:close="inputs.holidays = inputs.holidays.filter((item) => item != holiday)">{{ holiday.toDate() }}</v-chip>
                                <v-btn text icon class="align-self-center inputs-holidays-picker"> <v-icon> mdi-plus-circle </v-icon> </v-btn>
                            </v-chip-group>
                            <v-dialog width="300" activator=".inputs-holidays-picker">
                                <v-date-picker v-model="inputs.holidays" multiple class="v-sheet--outlined" />
                            </v-dialog>
                        </form-table-row>
                        <v-row no-gutters align="stretch">
                            <v-col cols="12" sm="6">
                                <form-table-row label="사용자 노출" cols="3" sm="6" fillHeight>
                                    <v-switch v-model="inputs.shpws" inset v-bind="attrs_switch" />
                                </form-table-row>
                            </v-col>
                            <v-col cols="12" sm="auto">
                                <v-divider v-if="$vuetify.breakpoint.smAndUp" vertical />
                                <v-divider v-else />
                            </v-col>
                            <v-col cols="12" sm="">
                                <form-table-row label="예약하기 비활성화" cols="3" sm="6">
                                    <v-switch v-model="inputs.isRentDisabled" inset v-bind="attrs_switch" />
                                </form-table-row>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider />
            <v-card-actions class="px-6 grey lighten-5">
                <v-spacer />
                <v-btn large color="primary" v-bind="{ loading }" @click="save"> 저장하기 </v-btn>
            </v-card-actions>
            <v-fade-transition>
                <v-overlay v-show="loading" absolute z-index="0" :dark="false" color="white">
                    <v-progress-circular indeterminate width="5" size="100" color="black" />
                </v-overlay>
            </v-fade-transition>
        </v-card>
    </v-dialog>
</template>

<script>
import api from "@/api";
import detect from "@/plugins/detect";
import { attrs_input, attrs_switch, RENTAL_SUBJECT_TYPES } from "@/assets/variables";

import ImagesInput from "../dumb/images-input.vue";
import FormTableRow from "../dumb/form-table-row.vue";
import VPreviewInput from "@/components/plugins/vuetify/v-preview-input.vue";

let hours = new Array(24).fill().map((_, index) => index);

const inintRentalSubject = () => ({
    _thumb: null,
    thumb: null,

    _photos: [],
    photos: [],

    type: RENTAL_SUBJECT_TYPES.FACILITIES.value,
    name: null,
    usage: null,
    isFree: false,
    charge: null,
    worker: null,
    detail: null,
    contact: null,
    location: null,
    holidays: [],
    businessDays: [1, 2, 3, 4, 5],
    businessHours: [...hours],
    isWholeDayRent: false,
    isRentDisabled: false,

    dateOfConstruction: null,
    classificationName: null,
    placeOfInstallment: null,
    rangeOfApplication: null,

    shows: true,
});

const isFreeItems = [
    { text: "유료", value: false },
    { text: "무료", value: true },
];
const subjectTypes = Object.values(RENTAL_SUBJECT_TYPES);
const businessDays = [
    { label: "일", value: 0 },
    { label: "월", value: 1 },
    { label: "화", value: 2 },
    { label: "수", value: 3 },
    { label: "목", value: 4 },
    { label: "금", value: 5 },
    { label: "토", value: 6 },
];
const businessHours = hours.map((value) => ({ label: `${value}시`, value }));
const isWholeDayRentItems = [
    { text: "시간제", value: false },
    { text: "종일제", value: true },
];

export default {
    components: {
        ImagesInput,
        FormTableRow,
        VPreviewInput,
    },
    props: {
        value: { type: Object },
    },
    data: () => ({
        shows: false,
        loading: false,

        inputs: inintRentalSubject(),

        attrs_input,
        attrs_switch,
        isFreeItems,
        subjectTypes,
        businessDays,
        businessHours,
        isWholeDayRentItems,

        isMobile: detect == "mobile",
    }),
    computed: {
        _subject() {
            return this.value?._id;
        },
        isCreate() {
            return !this._subject;
        },
        isEquipment() {
            return this.inputs?.type == RENTAL_SUBJECT_TYPES.EQUIPMENTS.value;
        },
    },
    watch: {
        shows() {
            if (this.shows) this.init();
        },
        "inputs.area.width"() {
            const { width = 0, height = 0 } = this.inputs.area;
            this.inputs.area.square = width * height || 0;
        },
        "inputs.area.height"() {
            const { width = 0, height = 0 } = this.inputs.area;
            this.inputs.area.square = width * height || 0;
        },
    },
    methods: {
        async init() {
            this.loading = true;
            try {
                if (this.isCreate) {
                    this.inputs = { ...inintRentalSubject() };
                } else {
                    let { subject } = await api.console.rental.subjects.get({ _id: this._subject });

                    subject.thumb = subject.thumb?.url ? await api.getResource(subject?.thumb.url, true) : null;
                    subject.photos = subject.photos?.length ? await Promise.all(subject.photos.map(async ({ url }) => await api.getResource(url, true))) : [];
                    subject.holidays = subject.holidays.map((date) => date.toDate());

                    this.inputs = subject;
                }
            } catch (error) {
                this.$handleError(error);
            } finally {
                this.loading = false;
            }
        },

        validate() {},

        async save() {
            if (this.loading) return;

            this.loading = true;
            try {
                this.validate();

                let { _thumb, thumb, _photos = [], photos = [], ...inputs } = this.inputs;

                // POST/PUT subject
                let { post, put } = api.console.rental.subjects;
                let { subject } = await (this.isCreate ? post(inputs) : put(inputs));
                let _subject = subject?._id;

                // DELETE/POST files

                // thumb
                if (_thumb) await api.console.rental.subjects.thumb.delete({ _id: _thumb, _subject });
                if (thumb) _thumb = (await api.console.rental.subjects.thumb.post({ _subject }, thumb))?.thumb?._id;
                else _thumb = null;

                // photos
                for (let _id of _photos) {
                    await api.console.rental.subjects.photos.delete({ _id, _subject });
                }
                for (let [index, photo] of photos.entries()) {
                    photos[index] = (await api.console.rental.subjects.photos.post({ _subject, index }, photo))?.photo;
                }
                if (photos.length) _photos = photos.map(({ _id }) => _id);
                else _photos = [];

                // PUT _units @subject
                subject = (await put({ _id: _subject, _thumb, _photos }))?.subject;

                alert("저장되었습니다");
                if (this.isCreate) this.$emit("created");
                else this.$emit("input", subject);
                this.shows = false;
            } catch (error) {
                this.$handleError(error);
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
